import { render, staticRenderFns } from "./SidebarBirth.vue?vue&type=template&id=e9906804&scoped=true&"
import script from "./SidebarBirth.vue?vue&type=script&lang=js&"
export * from "./SidebarBirth.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBirth.vue?vue&type=style&index=0&id=e9906804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9906804",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VSelect,VTextField})
